<template>
  <div class="listmain ">
      <h1 class="firTitle">第三方服务</h1>
      <h3 class="sedTitle">第三方平台账号绑我们的账号，并提供技能服务</h3>
          <highlight-code lang="javascript">
            <span>
/**
 * 获取平台信息并绑定账户
 *
 * @param skillId skillId
 * @param platformId platformId
 * @param sourceType 来源渠道
 * @param completion  block回调方法
 */
[[OrionSDK shared] bindBySkillId:@"19" withPlatformId:@"orion.ovs.rsplatform.0559260848" withSoureceType:OVSSourceTypeDefault withCompletion:^(NSDictionary * _Nullable conversationInfo, NSError * _Nullable error) {
    //返回内容是字典，需要里面的参数调用支付接口是需要拼接header注入时需要，遇到错误看错误描述
    NSLog(@"%@,%@",conversationInfo,error);
}];
            </span>
    </highlight-code>
      <h3 class="sedTitle">解绑第三方平台账号</h3>
      <highlight-code lang="javascript">
        <span>
            /**
 *解绑绑定平台账户
 *
 * @param skillId skillId
 * @param platformId platformId
 * @param completion  block回调方法
 */
[[OrionSDK shared] unbindBySkillId:@"19" withPlatformId:@"orion.ovs.rsplatform.0559260848" withCompletion:^(NSDictionary * _Nullable conversationInfo, NSError * _Nullable error) {
    NSLog(@"%@,%@",conversationInfo,error);
}];
        </span>
      </highlight-code>
      <h3 class="sedTitle">获取第三方平台的绑定信息</h3>
      <highlight-code lang="javascript">
        <span>
           /**
 * 获取第三方平台的绑定信息
 *
 * @param skillId skillId
 * @param platformId platformId
 * @param completion block回调方法
 */
[[OrionSDK shared] obtainBindInfoBySkillId:@"19" withPlatformId:@"orion.ovs.rsplatform.0559260848" withCompletion:^(NSDictionary * _Nullable conversationInfo, NSError * _Nullable error) {
    NSLog(@"%@,%@",conversationInfo,error);
}];
        </span>
      </highlight-code>

      <h3 class="sedTitle">打开小微的支付页面去续VIP费用</h3>
      <highlight-code lang="javascript">
         <span>
             /**
 * 去小微支付，支付成功回调结果
 *
 * @param headerContent 注入qq支付页面用户信息
 * @param completion  block回调方法
 */
//打开qq支付页面，headerContent内容是什么还不确定，可以理解注入网页地址一个cookie，可能参数会有调整
[[OrionSDK shared] xwPayWithHeaderContent:@"" completion:^(NSDictionary * _Nullable conversationInfo, NSError * _Nullable error) {
    NSLog(@"%@,%@",conversationInfo,error);
}];
         </span>
      </highlight-code>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">NOTE：headerContent内容是什么还不确定，可以理解注入网页地址一个cookie，可能参数需要调整
</span>
      </p>

      <h3 class="sedTitle">绑定qq登录并绑定小微服务封装版便捷本</h3>
      <highlight-code lang="javascript">
         <span>
             /**
 * 小微登录和绑定账户
 *
 * @param skillId skillId
 * @param platformId platformId
 * @param completion  block回调方法
 */
[[OrionSDK shared] xwLoginAndBindBySkillId:@"53" withPlatformId:@"orion.ovs.rsplatform.8140088984" withCompletion:^(NSDictionary * _Nullable conversationInfo, NSError * _Nullable error) {
    NSLog(@"%@,%@",conversationInfo,error);
}];

         </span>
      </highlight-code>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">NOTE：通过 3.11.1 和 3.11.6 组合也可以实现这个功能，请根据自己需求选择使用
</span>
      </p>
      <h3 class="sedTitle">绑定小微服务</h3>
      <highlight-code lang="javascript">
         <span>
             /**
 * 小微用户服务，可以绑定，更新绑定信息，解绑
 *
 * @param type 枚举类型
 * @param params 需要传入的参数
 * 参考范例：
 * @{
 * @"refresh_token":data[@"third_access_token"]?:@"",
 * @"qq_open_id":data[@"third_uid"]?:@""
 * }
 * @param completion 处理完成后回调结果
 */
[[OrionSDK shared] xwUserService:OVSQQUserServiceUnbind withParams:@{@"refresh_token":@"B17DD0DEA53174332B0790974B2AA3C3", @"qq_open_id":@"E18E732A05F160AB0B956FDDB22B5DC5"} witCompletion:^(NSDictionary * _Nullable conversationInfo, NSError * _Nullable error) {
    NSLog(@"%@,%@",conversationInfo,error);
}];
         </span>
      </highlight-code>
      <h3 class="sedTitle">解绑小微服务</h3>
      <highlight-code lang="javascript">
         <span>
          /**
 * 小微用户服务，可以绑定，更新绑定信息，解绑
 *
 * @param type 枚举类型
 * @param params 需要传入的参数
 * 参考范例：
 * @{
 * @"refresh_token":data[@"third_access_token"]?:@"",
 * @"qq_open_id":data[@"third_uid"]?:@""
 * }
 * @param completion 处理完成后回调结果
 */
[[OrionSDK shared] xwUserService:OVSQQUserServiceBind withParams:@{} witCompletion:^(NSDictionary * _Nullable conversationInfo, NSError * _Nullable error) {
    NSLog(@"%@,%@",conversationInfo,error);
}];
         </span>
      </highlight-code>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">解绑不需要传递参数，空字典即可
</span>
      </p>
      <h3 class="sedTitle">查询小微的vip信息</h3>
      <highlight-code lang="javascript">
         <span>
             /**
 * 查询小微的vip信息
 *
 * @param completion 请求完成后回调结果
 */
- (void)xwVipInfoCompletion:(nullable void(^)( NSDictionary * __nullable conversationInfo, NSError * __nullable error))completion {
    NSLog(@"%@,%@",conversationInfo,error);
}];
         </span>

      </highlight-code>
      <h3 class="sedTitle"> 查询小微账户的状态信息</h3>
      <highlight-code lang="javascript">
          <span>
              /**
 * 查询小微账户的状态信息
 *
 * @param completion 请求完成后回调结果
 */
- (void)xwAccountStatusCompletion:(nullable void(^)( NSDictionary * __nullable conversationInfo, NSError * __nullable error))completion {
    NSLog(@"%@,%@",conversationInfo,error);
}];
          </span>

      </highlight-code>

  </div>
</template>

<script>
export default {
  name: ""
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 30px;
    font-size: 16px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
    width: 100%;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-ios/access/ThirdParty.vue